import React from "react";
import { Box, Button, Grid, Paper, Stack, Typography } from "@mui/material";
import GrowthBarChart from "./graphs/GrowthBarChart";
import MarketCapGraph from "./graphs/MarketCapGraph";
import FutureTrends from "./graphs/FutureTrends";
import RiskFactorsChart from "./graphs/RiskFactorsChart";
import { StyledBox } from "./styles";
import Logo from "../assets/Logo.png";

const AIGraphs = ({ data, setShowGraphs }) => {
  return (
    <Box sx={{ py: 2 }}>
      <Box sx={{ display: "flex", alignItems: "center", width: "100%", mb: 4 }}>
        <Box sx={{ width: "30%" }}>
          <Button
            variant="outlined"
            color="green"
            onClick={() => setShowGraphs(false)}
          >
            Go Back
          </Button>
        </Box>

        <Box sx={{ flex: 1 }} />

        <Box sx={{ width: "50%" }}>
          <img src={Logo} alt="stat-icon" width={240} />
        </Box>

        <Box sx={{ flex: 1 }} />
      </Box>

      <Paper
        sx={{
          width: "49%",
          backgroundColor: "#151A27",
          borderRadius: "8px",
          p: 2,
          mb: 2,
          elevation: 3,
          boxShadow: "none",
        }}
      >
        <Typography variant="body2" color={"grey"}>
          Industry Type
        </Typography>
        <Typography
          variant="h5"
          color={"#fff"}
          sx={{ textTransform: "capitalize" }}
        >
          {data?.industry_type}
        </Typography>
      </Paper>

      <Typography variant="h3" color={"green.main"}>
        Statistics
      </Typography>

      <Grid container spacing={2} my={2}>
        <Grid item xs={12} md={12} lg={6}>
          <StyledBox>
            <GrowthBarChart
              industry={data?.industry_type}
              stats={data?.predicted_future.A}
            />
          </StyledBox>
        </Grid>

        <Grid item xs={12} md={12} lg={6}>
          <StyledBox>
            <MarketCapGraph stats={data?.predicted_future.B} />
          </StyledBox>
        </Grid>
      </Grid>

      <Stack direction="row" spacing={2}>
        <Typography variant="h3" color={"#fff"}>
          Future Trends -{" "}
        </Typography>
        <Typography variant="h3" color={"green.main"}>
          {" "}
          Next 5 Years
        </Typography>
      </Stack>
      <Box my={4}>
        <FutureTrends stats={data?.predicted_future.C} />
      </Box>
      <Stack direction="row" spacing={2}>
        <Typography variant="h3" color={"#fff"}>
          Risk factors for this
        </Typography>
        <Typography variant="h3" color={"green.main"}>
          Industry
        </Typography>
      </Stack>
      <RiskFactorsChart stats={data?.predicted_future.D} />
      <Box my={4}>
        <Typography variant="body1" color={"#fff"}>
          <b>Conclusion :</b> {data?.predicted_future.Conclusion}
        </Typography>
      </Box>
    </Box>
  );
};

export default AIGraphs;
